import styled from 'styled-components';

export const SectionContainer = styled.section`
  display: flex;
  justify-content: center;
  padding: 40px;
  flex-wrap: wrap;
  height: auto;

  img {
    width: 250px;
    height: auto;
  }

  a {
    color: inherit; /* blue colors for links too */
    text-decoration: inherit; /* no underline */
  }
`;

export const SectionTitle = styled.h2`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: bold;
  color: #002d55;
  font-size: 28px;
  line-height: 30px;
  align-items: center;
  text-align: center;
  margin-top: 42px;
`;
